import { createFeatureSelector, createSelector } from '@ngrx/store';
import { pipe, distinctUntilChanged } from 'rxjs';

import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';

import { LoyaltyState, MilestoneState, State } from '../../interfaces/store.interface';
import { LOYALTY_FEATURE_KEY } from '../../constants';

export const selectLoyaltyState = createFeatureSelector<State, LoyaltyState>(LOYALTY_FEATURE_KEY);

export const selectTripsState = createSelector(selectLoyaltyState, (state: LoyaltyState) => state.trips);
export const selectMilestonesState = createSelector(selectLoyaltyState, (state: LoyaltyState) => state.milestones);
export const dismissedWithPointsSelector = createSelector(
  selectMilestonesState,
  (milestones: MilestoneState) => milestones.dismissedWithPoints
);

export const dismissedWithPoints = (): StateSelector<State, number> =>
  pipe(safeSelect(dismissedWithPointsSelector), distinctUntilChanged());
